<template>
  <w-settings-content-template side-title="장치 목록">
    <w-physical-tree v-show="activeTab === 'WSyslogRule'" slot="sideContent" class="mr-r20" ref="sideRuleTree" managetype-id="NMS" @clickNode="onClickNode" :force-select-leaf="true"></w-physical-tree>
    <w-physical-tree v-show="activeTab === 'WSyslogCollect'" slot="sideContent" class="mr-r20" ref="sideCollectTree" managetype-id="NMS" @clickNode="onClickNode"></w-physical-tree>
    <el-tabs slot="content" type="card" v-model="activeTab" @change="onChangeTab">
      <el-tab-pane label="수집 설정" name="WSyslogCollect" class="h100 w100">
        <w-syslog-collect :selected-node="selectObjNode" ref="syslogCollect"></w-syslog-collect>
      </el-tab-pane>
      <el-tab-pane label="정책 설정" name="WSyslogRule" class="h100 w100">
        <w-syslog-rule :selected-node="selectRuleNode" ref="syslogRule"></w-syslog-rule>
      </el-tab-pane>
    </el-tabs>
  </w-settings-content-template>
</template>

<script>
import WPhysicalTree from '@/components/tree/DynamicPhysicalTree';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WSyslogRule from './SyslogRule';
import WSyslogCollect from './SyslogCollect';

export default {
  name: 'WSyslogSettings',
  components: {
    WSettingsContentTemplate,
    WSyslogRule,
    WSyslogCollect,
    WPhysicalTree,
  },
  data() {
    return {
      activeTab: 'WSyslogCollect',
      nodeData: null,
      selectRuleNode: null,
      selectObjNode: null,
      firstKey: null,
    };
  },
  methods: {
    onChangeTab(tab) {
      if (tab === 'WSyslogCollect') {
        this.$refs.syslogCollect.loadData();
      } else if (tab === 'WSyslogRule') {
        this.$refs.syslogRule.loadData();
      }
    },
    onClickNode(data) {
      if (data.type === 'group' || data.type === 'root') {
        this.selectObjNode = data;
      } else {
        this.selectRuleNode = data;
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/Syslog/index.vue